// Keyboard focus order for BucketSankeyChart. Pure functions -- no DOM, no React.
//
// The chart is one tab stop (roving tabindex): Tab lands on the active node or ribbon,
// and the arrow keys / Home / End move through the rest in this order.

/**
 * Focusable items in reading order: column by column, each column's nodes top to bottom
 * followed by the ribbons leaving it (by source, then target bucket). Nodes only when
 * nodes are clickable, ribbons only when ribbons are.
 *
 * @param {{ nodeMeta: Map, edgeMeta: Map }} graph  buildSankeyGraph result
 * @returns {{ kind: "node"|"edge", id: string, columnIndex: number }[]}
 */
export function buildFocusOrder(graph, { nodes = true, flows = true } = {}) {
  const items = [];
  if (nodes) {
    graph?.nodeMeta?.forEach((meta, id) => {
      items.push({ kind: "node", id, columnIndex: meta.columnIndex, a: meta.bucketIndex, b: 0, k: 0 });
    });
  }
  if (flows) {
    graph?.edgeMeta?.forEach((meta, id) => {
      items.push({ kind: "edge", id, columnIndex: meta.fromIndex, a: meta.fromBucket, b: meta.toBucket, k: 1 });
    });
  }
  return items
    .sort((x, y) => x.columnIndex - y.columnIndex || x.k - y.k || x.a - y.a || x.b - y.b)
    .map(({ kind, id, columnIndex }) => ({ kind, id, columnIndex }));
}

/**
 * Index to move to for a key, or null when the key does not move focus.
 * Down / Right: next; Up / Left: previous (both stop at the ends); Home / End: first / last.
 */
export function nextFocusIndex(key, index, length) {
  if (!(length > 0)) return null;
  const i = Number.isInteger(index) && index >= 0 && index < length ? index : 0;
  if (key === "ArrowDown" || key === "ArrowRight") return Math.min(i + 1, length - 1);
  if (key === "ArrowUp" || key === "ArrowLeft") return Math.max(i - 1, 0);
  if (key === "Home") return 0;
  if (key === "End") return length - 1;
  return null;
}
